import api from '../utils/api';

export async function createKnowledgeBase(payload) {
  const { data } = await api.post('/knowledge-bases/', payload);
  return data;
}

export async function createKnowledgeIngest(payload) {
  const { data } = await api.post('/knowledge-bases/ingest', payload);
  return data;
}

export async function listKnowledgeBases({ page = 1, perPage = 20 } = {}) {
  const { data } = await api.get('/knowledge-bases/', {
    params: { page, per_page: perPage },
  });
  return data;
}

export async function getKnowledgeBase(id) {
  const { data } = await api.get(`/knowledge-bases/${id}`);
  return data;
}

export async function updateKnowledgeBase(id, payload) {
  const { data } = await api.put(`/knowledge-bases/${id}`, payload);
  return data;
}

export async function deleteKnowledgeBase(id) {
  const { data } = await api.delete(`/knowledge-bases/${id}`);
  return data;
}

export async function updateDocumentUsageType(kbId, documentId, usageType) {
  const { data } = await api.patch(
    `/knowledge-bases/${kbId}/documents/${documentId}/usage-type`,
    { usage_type: usageType },
  );
  return data;
}

export async function getKnowledgeBaseFiles(id) {
  const { data } = await api.get(`/knowledge-bases/${id}/files`);
  return data;
}

export async function triggerKnowledgeSync(id) {
  const { data } = await api.post(`/knowledge-bases/${id}/sync`);
  return data;
}

export async function getGoogleDriveIngestInfo() {
  const { data } = await api.get('/knowledge-bases/ingest/google-drive/info');
  return data;
}
